export default {
    label_task:{
        en:"Distributor vs Dealer Sales Report",
        bn:'Variety Report'
    },
    label_achievement :{
        en:"(%) Dealer Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_eligible:{
        en:"Eligible Quantity",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_target:{
        en:"Target Quantity",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_sales_net:{
        en:"Sales Quantity",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_bonus_adjusted:{
        en:"Bonus Eligible Qty Adjusted",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_balance:{
        en:"Balance Qty",
        bn:'ব্যবহারকারীরা'
    },
    label_num_bonus_eligible:{
        en:"No. of Bonus Eligible",
        bn:'ব্যবহারকারীরা'
    },
    label_num_bonus_delivered:{
        en:"No. of Bonus Delivered",
        bn:'ব্যবহারকারীরা'
    },
    label_num_bonus_delivery_pending:{
        en:"No. of Bonus Delivery Pending",
        bn:'ব্যবহারকারীরা'
    },


}